// removed by extract-text-webpack-plugin
module.exports = {"hero":"_2a0R4DP4cuMAOjaJONiK2Z","title":"_33PDFyvOONHjxkrUNnxRCd","heroText":"_1f10PT0AQAo6MXqETqhrhT","heroTitle":"_2PyNw5XJsB45k2EjN6w-eg","btn":"Sgm2LaY6eNHJvp6S2mEnz","awards":"_3ZOcKiTrXhHMMcNdPDX0AC","prize":"_1vKrTfYLe3FMYcD2-XmIoT","competition":"_1Eg6OXW14l7qwyXR9Ocitn","organization":"_28GW46j8_StJAXUuafTrSp"};


/*****************
 ** WEBPACK FOOTER
 ** ./index.module.scss
 ** module id = 1755
 ** module chunks = 0
 **/